module.exports = {"220182001":"华昌街道","220182002":"正阳街道","220182003":"培英街道","220182004":"城郊街道","220182100":"五棵树镇","220182101":"弓棚镇","220182102":"闵家镇","220182103":"大坡镇","220182104":"黑林镇","220182105":"土桥镇","220182106":"新立镇","220182107":"大岭镇","220182108":"于家镇","220182109":"泗河镇","220182110":"八号镇","220182111":"刘家镇","220182112":"秀水镇","220182113":"保寿镇","220182114":"新庄镇","220182200":"育民乡","220182201":"红星乡","220182202":"太安乡","220182203":"先峰乡","220182204":"青山乡","220182205":"延和朝鲜族乡","220182206":"恩育乡","220182207":"城发乡","220182208":"环城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220182.json
// module id = 703
// module chunks = 0